import React from 'react';
import './Facts.css';


function Facts() {
  return (
    <div  className="facts">
        <h1> Facts About India</h1>
        <div className="fact-container">
        <div className='facts__wrapper'>
          
          <ul className='facts__items'>
            <li className='facts__item'>
                <div className="facts_card">
                    <div className='facts__item__info'>
                        <h5 className='facts__item__text'>The name ‘India’ derives from the river Indus.</h5>
                        <h5 className='facts__tags'><span><i class="fa fa-tag" aria-hidden="true"></i></span>  General</h5>
                    </div>
                </div>
                
            </li>
            <li className='facts__item'>
                <div className="facts_card">
                    <div className='facts__item__info'>
                        <h5 className='facts__item__text'>India has the second-largest population in the world.</h5>
                        <h5 className='facts__tags'><span><i class="fa fa-tag" aria-hidden="true"></i></span>  General</h5>
                    </div>
                </div>
            </li>
            <li className='facts__item'>
                <div className="facts_card">
                    <div className='facts__item__info'>
                        <h5 className='facts__item__text'>Tata Motors dominates over 60% of the Indian commercial vehicle market.</h5>
                        <h5 className='facts__tags'><span><i class="fa fa-tag" aria-hidden="true"></i></span>  Trade</h5>
                    </div>
                </div>
            </li>
          </ul>
          <ul className='facts__items'>
            <li className='facts__item'>
                <div className="facts_card">
                    <div className='facts__item__info'>
                        <h5 className='facts__item__text'>Thousands of languages are spoken all over India.</h5>
                        <h5 className='facts__tags'><span><i class="fa fa-tag" aria-hidden="true"></i></span>  General</h5>
                    </div>
                </div>
                
            </li>
            <li className='facts__item'>
                <div className="facts_card">
                    <div className='facts__item__info'>
                        <h5 className='facts__item__text'>The national symbol of India is the endangered Bengal Tiger.</h5>
                        <h5 className='facts__tags'><span><i class="fa fa-tag" aria-hidden="true"></i></span>  General</h5>
                    </div>
                </div>
            </li>
          </ul>
          <ul className='facts__items'>
            <li className='facts__item'>
                <div className="facts_card">
                    <div className='facts__item__info'>
                        <h5 className='facts__item__text'>Hinduism, the world’s oldest religion, is the most popular religion in India.</h5>
                        <h5 className='facts__tags'><span><i class="fa fa-tag" aria-hidden="true"></i></span>  General</h5>
                    </div>
                </div>
                
            </li>
            <li className='facts__item'>
                <div className="facts_card">
                    <div className='facts__item__info'>
                        <h5 className='facts__item__text'>India is the second largest English speaking country in the world.</h5>
                        <h5 className='facts__tags'><span><i class="fa fa-tag" aria-hidden="true"></i></span>  General</h5>
                    </div>
                </div>
            </li>
            <li className='facts__item'>
                <div className="facts_card">
                    <div className='facts__item__info'>
                        <h5 className='facts__item__text'>India gained independence from Britain in 1947.</h5>
                        <h5 className='facts__tags'><span><i class="fa fa-tag" aria-hidden="true"></i></span>  General</h5>
                    </div>
                </div>
            </li>
          </ul>
          <ul className='facts__items'>
            <li className='facts__item'>
                <div className="facts_card">
                    <div className='facts__item__info'>
                        <h5 className='facts__item__text'>Superstar Freddie Mercury is of Indian origin.</h5>
                        <h5 className='facts__tags'><span><i class="fa fa-tag" aria-hidden="true"></i></span>  General</h5>
                    </div>
                </div>
                
            </li>
            <li className='facts__item'>
                <div className="facts_card">
                    <div className='facts__item__info'>
                        <h5 className='facts__item__text'>70% of all the world’s spices come from India.</h5>
                        <h5 className='facts__tags'><span><i class="fa fa-tag" aria-hidden="true"></i></span>  General</h5>
                    </div>
                </div>
            </li>
          </ul>
        </div>
        </div>
    </div>
  );
}

export default Facts;
